import React from "react";
import { get } from "lodash";
import { TransitionMotion, spring } from "react-motion";
import Modal from "~/components/Modal";
import Spinner from "~/components/Spinner";
import { setPlaySourcePrefix } from "~/tools/analytics/cleverTap";
import { ellipsifyByChar, ellipsifyByWord} from '~/tools/strings/ellipsify'
import {
  differenceInYears,
  differenceInDays,
  differenceInHours,
  isPast
} from "date-fns";
import "./styles.css";

class ListItem extends React.Component {
  state = {
    library: this.props.header === "My Library",
    isPurchasable: false
  }

  componentDidUpdate(prevProps) {
    if (prevProps.items !== this.props.items) {
      if (this.props.items[0] && this.props.items[0].title === "Season Pass") {
        this.setState({ isPurchasable: true });
      }
    }
  }
  handleClick = (e, i, season, item) => {
    const { trayTitle, isEpisode, openEpisodeOverlay } = this.props || {}
    const title = trayTitle ? trayTitle : "";
    setPlaySourcePrefix(title);
    if (isEpisode) {
      openEpisodeOverlay(e, i, season, item);
    }
  };

  calculateDiff = date => {
    let today = Date.now();
    let unit;

    if (this.state.library) {
      unit = "Remaining";
      today = date;
      date = Date.now();
    } else {
      unit = "Ago";
    }

    const years = differenceInYears(today, date);
    const days = differenceInDays(today, date);
    const hours = differenceInHours(today, date);

    if (days < 1) {
      if (hours === 0) {
        return this.state.library ? "< 1 hour remaining" : "Added < 1 hour ago";
      } else {
        return `${hours} ${hours > 1 ? "Hours" : "Hour"} ${unit}`;
      }
    } else if (years < 1) {
      return `${days} ${days > 1 ? "Days" : "Day"} ${unit}`;
    } else {
      return `${years} ${years > 1 ? "Years" : "Year"} ${unit}`;
    }
  };

  renderItems = (item, i) => {
    const isPurchasable = this.state.isPurchasable
    const image = {
      backgroundImage:
        "url(" + (item.videoImageUrl || item.posterImageUrl) + ")"
    };
    const progressValue = Math.floor((item.watchedTime / item.runtime) * 100);
    const ellipsifyBy = !item.free ? 8 : 15
    const isEpisodePurchasable =
      !item.free &&
      (item.pricing && item.pricing.purchase !== null) &&
      item.purchaseStatus !== "PURCHASED" &&
      this.props.isEpisode;
    return (
      <div className="list__item__container">
        <a
          href={`${item.permalink}?start=${item.watchedTime}`}
          className="list__item__title"
          onClick={e => this.handleClick(e, i, this.props.season, item.container)}
        >
          <div className="container">
            <figure className="image-container">
              <div className="image" style={image} />
              <i className="ion-ios-play site-color" />
            </figure>
            {progressValue ? (
              <progress
                className="site-color"
                value={progressValue}
                max="100"
              />
            ) : (
              ""
            )}
          </div>
          <div className={`title-container ${isEpisodePurchasable ? 'purchasable' : ''}`}>
            <div className="title">
              { this.props.isEpisode && (
                <span className="episode-number">
                  { isPurchasable ? i : i + 1 }
                </span>
              ) }{" "}
              { isEpisodePurchasable ? ellipsifyByChar(item.title, 25) : item.title }
            </div>
            { item.description || item.seasonTitle ? (
              <div
                className="description"
                dangerouslySetInnerHTML={{
                  __html: item.description
                    ? ellipsifyByWord(item.description, ellipsifyBy, ellipsifyBy)
                    : `${item.seasonTitle} - ${
                        item.videoId.split(",").length
                      } episode(s)`
                }}
              />
            ) : (
              ""
            ) }
            { isEpisodePurchasable && (
              <div className="episode-purchasable cta">
                Purchase {window.settings.internalName.includes('bingeflix') ? 'Program' : 'Episode'} 
              </div>
            ) }
          </div>
        </a>
        {this.state.library ? (
          item.transactionEndDate && !isPast(item.transactionEndDate * 1000) ? (
            <div className="remaining-box site-background-color">
              <span className="remaining-time">
                {this.calculateDiff(item.transactionEndDate * 1000)}
              </span>
            </div>
          ) : (
            <div />
          )
        ) : (
          <div className="list__right__container">
            {this.props.header !== "Watchlist" ? (
              <div className="days-ago">
                {this.calculateDiff(item.updateDate)}
              </div>
            ) : (
              ""
            )}
            <div
              className="list__item__remove"
              onClick={() => this.props.deleteItem(item)}
            >
              <i className="link ion-close" />
            </div>
          </div>
        )}
      </div>
    );
  };

  render() {
    let items = this.props.items ? this.props.items : [];
    const styles =
      items &&
      items.map(item => ({
        key: item.id,
        style: { progress: spring(1) },
        data: item
      }));
    const titleColor = get(window.settings, "brand.general.blockTitleColor");

    // if(styles === undefined) return <div></div>;
    return (
        <div className="list">
          <div className="list__header">
            <div className="list__header__title" style={{ color: titleColor }}>
              {this.props.header}
            </div>
            {items.length > 0
              ? !this.state.library && (
                  <div className="clear-list">
                    <button onClick={this.props.toggleModal}>
                      clear {this.props.header}
                    </button>
                  </div>
                )
              : ""}
          </div>
          {this.props.deleteAllModal && (
            <Modal
              title="Delete All"
              shown={this.props.deleteAllModal}
              className="modal-confirm"
              closeModal={this.props.toggleModal}
              clear={this.props.clear}
              showButtons={true}
            >
              <span style={{ color: "#fff" }}>Are You Sure?</span>
            </Modal>
          )}
          {!this.props.fetching && items.length === 0 ? (
            <div className="list-empty">Your list is Empty!</div>
          ) : (
            ""
          )}
          <div className="list__body">
            {styles ? (
              <TransitionMotion
                // willAppear styles
                // defaultStyles={styles.map(style => ({
                //   key: style.key,
                //   style: { progress: 0 },
                // }))}
                styles={styles}
                willEnter={() => ({ progress: 0 })}
                willLeave={() => ({ progress: spring(0) })}
              >
                {styles => (
                  <div className="list__body__container">
                    {styles.map((style, i) =>
                      style.data.title === "Season Pass" ? (
                        <div
                          key={style.key}
                          onClick={
                            this.props.isEpisode &&
                            (e => {
                              this.props.openEpisodeOverlay(e, i, this.props.season, style.data.container);
                            })
                          }
                          className="season-pass cta"
                        >
                          Purchase {window.settings.internalName.includes('bingeflix') ? '' : 'Season'} 
                        </div>
                      ) : (
                        style.data.permalink && (
                          <div
                            className="list__item"
                            key={style.key}
                            style={{
                              height: 100 * style.style.progress,
                              opacity: style.style.progress
                            }}
                          > 
                            {this.renderItems(style.data, i)}
                          </div>
                        )
                      )
                    )}
                  </div>
                )}
              </TransitionMotion>
            ) : (
              ""
            )}
          </div>
          {this.props.fetching && <Spinner />}
        </div>
    );
  }
}

export default ListItem;
